/**
 * Connector Label - shows connector type indicator next to item names
 */

import { cn } from '@loader/ui';
import type { ConnectorType } from '@loader/shared-types';

import { CONNECTOR_META } from '@/features/inputs/types';

const CONNECTOR_FALLBACK_LABEL = 'integration';

function getConnectorLabel(type: ConnectorType): string {
  return CONNECTOR_META[type]?.label ?? CONNECTOR_FALLBACK_LABEL;
}

interface ConnectorLabelProps {
  connectorType: ConnectorType;
  size?: 'xs' | 'sm';
  isSelected?: boolean;
}

export function ConnectorLabel({ connectorType, size = 'xs', isSelected }: ConnectorLabelProps) {
  const label = getConnectorLabel(connectorType);
  const sizeClass = size === 'xs' ? 'text-xs' : 'text-sm';
  const colorClass = isSelected ? 'text-primary-foreground/60' : 'text-muted-foreground/60';

  return (
    <>
      <span className={cn(sizeClass, 'shrink-0', colorClass)}>·</span>
      <span className={cn(sizeClass, 'shrink-0', colorClass)}>{label}</span>
    </>
  );
}
